// Compara un item por nombre o acrónimo.
export function matchNamed(item: any, value: string) {
    if (namedHit(item, value)) return true;
    return acronymHit(item, value);
}

// Compara el nombre sin mayúsculas.
export function namedHit(item: any, value: string) {
    return item.name.toLowerCase().includes(value.toLowerCase());
}

// Compara el acrónimo con el valor.
export function acronymHit(item: any, value: string) {
    return item.acronym.toLowerCase().includes(value);
}

// Filtra items por texto.
export function filterNamed(items: any[], value: string) {
    const found: any[] = [];
    for (const item of items) addNamedMatch(item, found, value);
    return found;
}

// Agrega un item coincidente.
export function addNamedMatch(item: any, found: any[], value: string) {
    if (matchNamed(item, value)) found.push(item);
}

// Elige items filtrados o todos.
export function pickNamed(items: any[], value: string) {
    if (value) return filterNamed(items, value);
    return items;
}
